import './attachment_view.js.coffee';# Added by Script 
Customer.Ticket ||= {}

class Customer.Ticket.ResponseAttachmentView extends Customer.Ticket.AttachmentView
  template: JST['backbone/templates/customer/ticket/attachment/response_attachment']

  initialize: (el, response, subtype) ->
    super(el, response)
    @subtype = subtype
    @existingAttachments = []
    @defaultExistingAttachments = []
    @defaultAttachmentsSet = false

  render: ->
    @$el.html(@template())
    element = @$el.find('.file-upload-input')
    @appendFileUploadPlugin(element)

  appendFileUploadPlugin: (element) ->
    json =
      url: "/customer/attachment_upload?social_content_subtype=#{@subtype}"
      dataType: 'json'
      sequentialUploads: true
      add: @add
      done: @done
      fail: @fail
    element.fileupload json

  add: (e, data) =>
    @_formatFiles(data)
    file = @_fileFromData data
    label = new Customer.Ticket.ResponseAttachmentLabelView(@, file)
    label.render()
    @trigger('add:attachment')
    @_setLabel data, label
    @_disableAddAttachmenntButton() if @subtype == 'fb-message' || @subtype == 'whatsapp_message'
    @listenTo(label, 'remove:attachment', () =>
      @_enableAddAttachmenntButton()
      @trigger('remove:attachment')
    )
    data.submit();
    @files.push label
    @_checkReady()
    @setAttachmentsSize()

  done: (e, data) =>
    response = JSON.parse(data.xhr().response)
    if(response.success != false)
      label = @_labelFromData(data)
      @_saveResponse(data.xhr().response, label)
      label.setReady()
      @_checkReady()
      @trigger('upload:attachment')
    else
      @fail(e, data, response.message)

  fail: (e, data, message)=>
    label = @_labelFromData(data)
    label.destroy()
    @deleteFile(label)
    @_checkReady()
    @_showError(message)

  _showError: (message) ->
    window.showError(message)

  deleteFile: (label)->
    @files = _.filter @files, (file)-> file != label
    @setAttachmentsSize()

  deleteExistingAttachment: (label) =>
    @existingAttachments = _.filter @existingAttachments, (attachment) -> attachment != label

  setDefaultExistingAttachments: (attachments) =>
    unless @defaultAttachmentsSet
      @defaultAttachmentsSet = true
      @defaultExistingAttachments = attachments
    @defaultExistingAttachments

  createExistingFileLabel: (file) =>
    existingAttachmentView = new Customer.Ticket.ResponseExistingAttachmentLabelView(attachment: @, file: file)
    @$el.append(existingAttachmentView.render().$el)
    @existingAttachments.push(existingAttachmentView)
    @listenTo(existingAttachmentView, 'remove:attachment', =>
      @_enableAddAttachmenntButton()
      @trigger('remove:existingAttachment', file)
    )

  hasEmptyExistingAttachments: =>
    _.isEmpty(@existingAttachments)

  clearAllAttachments: =>
    fileView.remove() for fileView in @files
    existingAttView.remove() for existingAttView in @existingAttachments
    @files = []
    @existingAttachments = []

  removeFromExistingAttachments: (file) =>
    file_url = file.file_url || file.url
    @existingAttachments = _.filter @existingAttachments, (attachment) ->
      current_attachment_url = attachment.file.file_url || attachment.file.url
      current_attachment_url != file_url

  restoreDefaultAttachments: (interaction, silent = false) =>
    return unless @defaultAttachmentsSet
    interactionValues = interaction.getValues()
    if _.isEmpty(interactionValues.attachments)
      @_restoreJsonAttachments(interaction, silent)
    else
      @_restoreAttachments(interaction, silent)

  setAttachmentsSize: () =>
    totalSize = _.reduce(@files || [], ((sum, label) -> sum + label.file.size), 0)
    attachmentsSizeLabel = @$el.find('.attachments-size')
    total = I18n.t('customer.dashboard.conversations.details.response.attachment.total')
    attachmentsSizeLabel.text(' (' + total + ': ' + @_prettyBytes(totalSize) + ')')

  _restoreJsonAttachments: (interaction, silent = false) =>
    restoredJsonAttachments = {}
    restoredJsonAttachments.data = @defaultExistingAttachments
    interactionData = Object.assign({}, interaction.get('data'))
    dataContent = Object.assign({}, interactionData.content)
    dataContent.attachment = JSON.stringify(restoredJsonAttachments)
    interactionData.content = dataContent
    interaction.set('data', interactionData, silent: silent)

  _restoreAttachments: (interaction, silent = false) =>
    restoredAttachments = @defaultExistingAttachments
    interactionData = Object.assign({}, interaction.get('data'))
    dataContent = Object.assign({}, interactionData.content)
    dataContent.attachments = restoredAttachments
    interactionData.content = dataContent
    interaction.set('data', interactionData, silent: silent)

  _checkReady: ()->
    ready = _.all @files, (item)-> item.isReady()
    @response.toggleSendButton(ready)
    ready

  _fileFromData: (data)->
    data.files[0]

  _labelFromData: (data)->
    data.files[0].label

  _setLabel: (data, label)->
    data.files[0].label = label

  _saveResponse: (response, label)->
    res = JSON.parse(response)
    label.setResponse(res)

  _disableAddAttachmenntButton: ->
    $addAttachmentButton = @$el.find('#add-direct-attachment-file-btn')
    $addAttachmentButton.addClass('disabled')

  _enableAddAttachmenntButton: ->
    $addAttachmentButton = @$el.find('#add-direct-attachment-file-btn')
    $addAttachmentButton.removeClass('disabled')

  _prettyBytes: (size, decimalPlaces = 2)=>
    index = Math.floor(Math.log(size) / Math.log(1024))
    unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][index]
    (size / Math.pow(1024, index)).toFixed(decimalPlaces) * 1 + ' ' + unit

  _formatFiles: (data) =>
    data.originalFiles = @_downcaseExtension(data.originalFiles)
    data.files = @_downcaseExtension(data.files)

  _downcaseExtension: (files) =>
    downcasedFiles = files.map((file) ->
      ext = file.name.split('.').slice(-1)[0]
      if (ext != ext.toLowerCase())
        lowerCaseName = file.name.split('.').slice(0,-1).join('.') + '.' + ext.toLowerCase()
        blob = file.slice(0, file.size, file.type)
        file = new File([blob], lowerCaseName, {type: file.type})
      return file
    )
    return downcasedFiles
